<style scoped lang="scss">
.wrapper {
  margin: 0 auto 10px;
}

.header {
  display: flex;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #999999;
  .back {
    margin-right: 20px;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -3px;
    }
    span {
      padding-left: 2px;
      &:hover {
        color: $color-theme;
      }
    }
  }
}

.main {
  min-height: calc(100vh - 170px);
  border-radius: 6px;
  background-color: #fff;
  .data-container {
    padding: 30px 40px;
    .title {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      opacity: 1;
    }
  }
  .task {
    .head {
      width: 450px;
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .head-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h3 {
          width: 0;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #2877FF;
          font-size: 20px;
        }
        span {
          width: 145px;
          color: #2877FF;
          font-size: 16px;
        }
      }
      .head-label {
        display: flex;
        justify-content: space-between;
        span {
          font-size: 16px;
          color: #333;
        }
      }
    }
    .tail {
      height: 50px;
      line-height: 50px;
    }
  }
  .pagination {
    float: right;
    margin-bottom: 10px;
    .el-pagination {
      padding-right: 0;
    }
  }
}
// 无数据
.no-data {
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100px;
    height: 79px;
  }
  p {
    padding-left: 32px;
    color: #999;
  }
}
.tips {
  font-size: 16px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  line-height: 24px;
  color: rgba(71, 142, 255, 1);
  opacity: 1;
}
</style>

<style lang="scss">
.task-list {
  .export-form {
    text-align: center;
    .el-dialog__body {
      padding: 20px 20px 0;
      h3 {
        text-align: center;
        font-size: $font-size-large;
        color: #333;
        margin: 25px 0;
      }
    }
    .el-dialog__footer {
      text-align: center !important;
    }
  }
}
</style>

<template>
  <div class="wrapper task-list">
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="8" />
        <span>返回</span>
      </div>
    </header>

    <div class="main">
      <div class="data-container" >
        <div style="display:flex;justify-content:space-between;">
          <span class="title">{{taskName}}分班记录列表</span>
          <span>
          <el-button type="text" @click="addRecord">新增记录</el-button>
          <el-button type="text" @click="refresh">刷新</el-button>
          </span>
        </div>
        <el-table stripe :data="dataList" v-loading="loading">
          <el-table-column align="center" prop="recordName" label="记录名称"></el-table-column>
          <el-table-column align="center" prop="recordStatus" label="状态">
            <template slot-scope="scope">
              <div v-if="scope.row.recordStatus === 0">
                <span style="color:red">未保存</span>
              </div>
              <div v-if="scope.row.recordStatus === 1">
                <span style="#478EFF">
                  <i class="el-icon-loading"></i>
                </span>
                <span style="#478EFF">正在保存</span>
              </div>
              <div v-if="scope.row.recordStatus === 2">
                <span style="color:#50C890">
                  <i class="el-icon-success"></i>
                </span>
                <span style="color:#50C890">保存完成</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="recordDetail(scope.row)">查看</el-button>
              <el-button type="text" @click="delRecord(scope.row)">删除</el-button>
              <el-button type="text" @click="exportRecord(scope.row)">导出</el-button>
              <el-button type="text" @click="updateRecord(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/common/SearchBar";

import { mapGetters } from "vuex";
import { listRecord, delRecord } from "@/api/tool";
import { domain } from "@/config";
export default {
  data() {
    return {
      taskName:'',
      taskId: "",
      currentRow: {},
      dialogVisible: false,
      dialogVisible2: false,
      recordName: "",
      dataList: [],
      keyword: "",
      schoolId: "",
      loading: false
    };
  },
  components: {
    SearchBar
  },
  mounted() {
    this.schoolId = this.userInfo.schoolId;
    this.taskId = this.$route.query.taskId;
    this.taskName = this.$route.query.taskName;
    this._getList();
  },

  methods: {
    refresh(){
      this._getList()
    },
    updateRecord(row){
      this.$router.push(
        "/tool/classAssign/create_step2?taskId=" +
          this.taskId +
          "&recordId=" +
          row.id +
          "&recordName=" +
          row.recordName + 
          "&taskName=" + this.taskName
      );
    },
    recordDetail(row) {
      if(row.recordStatus != 2){
        return this.$message.warning('该记录暂未保存完成')
      }
      this.$router.push(
        "/tool/classAssign/rankDetail?taskId=" +
          this.taskId +
          "&recordId=" +
          row.id +
          "&recordName=" +
          row.recordName
      );
    },
    exportRecord(row) {
      if(row.recordStatus != 2){
        return this.$message.warning('该记录暂未保存完成')
      }
      let url =
        domain +
        `/marking-main/divide/download_divide_result?taskId=${
          this.taskId
        }&recordId=${row.id}&token=${YJ_SCHOOL_STORAGE.getItem('token')}`;
      window.open(url);
    },
    delRecord(row) {
      this.$confirm("确认删除该记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await delRecord({
            recordId: row.id
          });
          if (res.code == 200) {
            this.$message.success("删除成功");
            this._getList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    addRecord() {
      this.$router.push("/tool/classAssign/create_step2?taskId=" + this.taskId + '&taskName=' + this.taskName);
    },
    async _getList() {
      this.loading = true
      let res = await listRecord({
        taskId: this.taskId
      });
      this.loading = false
      if (res.code == 200) {
        this.dataList = res.result;
      } else {
        this.$message.error(res.message);
      }
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  }
};
</script>
